import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { PatientService } from '../services/patient.service';
import { ToolService } from '../services/tool.service';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('ShowHide', [
      state('show', style({
        opacity : 1,
        display : "flex",
        transform : "translateX(0px)"
      })),
      state('hide', style({
        opacity : 0,
        display : "none",
        transform : "translateX(-300px)"
      })),
      transition('show => hide', [
        animate('0.25s')
      ]),
      transition('hide => show', [
        animate('0.25s')
      ]),
    ]),
  ]
})
export class LoginComponent implements OnInit {

  public State = 'check';
  public number = "";

  constructor(private service : PatientService, private tool : ToolService, private router : Router, private storage : Storage, private alertController: AlertController) { }

  ngOnInit() {}

  Check(nationalCode){
    if(!/\S/.test(nationalCode)){
      this.tool.WarningToast("مشخصات وارد نشده است");
      return;
    }
    
    if(!this.tool.IsNationalCodeValid(nationalCode)){
      this.tool.WarningToast("کد ملی درست وارد نشده است");
      return;
    }

    this.service.CheckAccount(nationalCode).toPromise()
    .catch(error =>{
      if(error){
        if(error.status == 0){
          this.tool.WarningToast("به اینترنت متصل نیستید");
          return;
        }
        if(error.status == 429){
          this.tool.DangerToast("لطفا چند دقیقه دیگر دوباره امتحان کنید");
          return;
        }
        if(error.error.message != null){
          this.tool.DangerToast("شما پرونده ای در سامانه xray ندارید");
          return;
        }
        if(error.error.data == null){
          this.State = 'create';
          return;
        }
      }
    })
    .then(result =>{
      if(result){
        this.number = result.data.Phone;
        this.State = 'login';
        return;
      }
    })    
  }

  Create(nationalCode, phone){
    if(!/\S/.test(phone)){
      this.tool.WarningToast("مشخصات وارد نشده است");
      return;
    }
    
    if(!this.tool.IsNationalCodeValid(nationalCode) || !this.tool.IsPhoneNumberValid(phone)){
      this.tool.WarningToast("مشخصات به درستی وارد نشده است");
      return;
    }

    this.service.CreateAccount(nationalCode, phone).toPromise()
    .catch(err =>{
      if(err){
        if(err.status == 0){
          this.tool.WarningToast("به اینترنت متصل نیستید");
          return;
        }  
        if(err.status == 429){
          this.tool.DangerToast("لطفا چند دقیقه دیگر دوباره امتحان کنید");
          return;
        }
        if(err.status == 409){
          this.tool.DangerToast("این شماره ثبت شده است");
          return;
        }
        if(err.status == 404){
          this.tool.DangerToast("شما پرونده ای در سامانه xray ندارید");
          return;
        }
        this.tool.DangerToast("مشکلی رخ داده است");
      }
    })
    .then(res =>{
      if(res){
        this.number = phone;
        this.State = 'login';
        return;
      }
    })
  }

  Login(nationalCode, code){
    if(!/\S/.test(code)){
      this.tool.WarningToast("کد تاییده وارد نشده است");
      return;
    }
    
    if(!this.tool.IsNationalCodeValid(nationalCode) || !/^[0-9]*$/.test(code) || code.length < 5){
      this.tool.WarningToast("مشخصات به درستی وارد نشده اند");
      return;
    }

    this.service.Login(nationalCode, code).toPromise()
    .catch(err =>{
      if(err){
        if(err.status == 0){
          this.tool.WarningToast("به اینترنت متصل نیستید");
          return;
        }  
        this.tool.DangerToast("کد تاییدیه اشتباه میباشد");
      }
    })
    .then(res =>{
      if(res){
        localStorage.setItem("access_key", res.data.token)
        this.storage.set("my_info", res.data.Name)
        .then(() =>{
          this.router.navigate(['/dashboard']);
        })
      }
    })
  }

  PresentChangePhoneNumberAlert(nationalcode ,phone) {
    this.alertController.create({
      header: 'شماره تلفن جدید را وارد نمایید',
      animated: true,
      cssClass: 'rtl',
      inputs: [
        {
          name: 'txtPhone',
          type: 'text',
          placeholder: 'تلفن همراه',
          value: phone,
          cssClass: 'ltr'
        }
      ],
      buttons: [
        {
          text: 'لغو',
          role: 'cancel'
        }, {
          text: 'تایید',
          handler: (e) => {
            if(!/\S/.test(e.txtPhone)){
              this.tool.DangerToast("شماره تلفنی وارد نشده است");
              return;
            }
            
            if(!this.tool.IsPhoneNumberValid(e.txtPhone)){
              this.tool.DangerToast("شماره تلفن به درستی وارد نشده است");
              return;
            }

            this.service.ChangePhoneNumber(nationalcode, e.txtPhone).toPromise()
            .catch(err =>{
              if(err){
                this.tool.DangerToast("نمیتوانید شماره خود را به این شماره تغییر دهید");
                return;
              }
            })
            .then(res =>{
              if(res){
                this.tool.SuccessToast("شماره تلفن به موفقیت تغییر یافت");
                this.Check(nationalcode);
              }
            })
          }
        }
      ]
    })
    .then(a => a.present());
  }

}